import { Cartographer } from "../cartographer.js"
import { Map } from "../components/map.js"
import { Helper } from "../../core/util/helper.js";
import { MetaDataHelper } from "../../core/util/metaDataHelper.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { GeomapService } from "../geomapService.js";
import { CheckBox } from "../../core/components/checkBox.js";
import { ComponentHelper } from "../../core/util/componentHelper.js";
import { IsNumericTextBox, NumericTextBoxField } from "../../core/components/isNumericTextBox.js";
import { TextBox, TextBoxField } from "../../core/components/textBox.js";
import { Button } from "../../core/components/button.js";
import { DropDownList } from "../../core/components/dropDownList.js";
import { HTTPService } from "../../core/util/httpManager.js";
import { Entity } from "../../core/components/commonApp.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";
export default class GeoCode extends React.Component<any, any>{
    private _address: any;

    private _geomapService: GeomapService;
    private _addressLine: string;
    private _cartographer: Cartographer;
    private factory = ComponentHelper.createFactory();
    private _geoCodeOwner: GeoCodeOwner;

    private _landDictionary: StringKeyDictionary<string> = null;
    
    constructor(props) {
        super(props);
        this._geomapService = new GeomapService();
        $(window).on("tabStripTabSelected", (_) => {
            if (this.state.translations != null && this.state.pinConfig != null) {
                this._setAddress();
                this._refresh();
            }
        });
        this.state = { translations: null, pinConfig: null };
    }

    private _setGeocodeValues = (lat: number, lng: number) => {
        this.props.onChange(this._createNumericLatField(this.props.latModel), lat);
        this.props.onChange(this._createNumericLngField(this.props.lngModel), lng);
    }
    
    private _getValue = (entity: Entity, model: string) => {
        let value = MetaDataHelper.getFieldValue(entity, model)
        if (value == null)
            value = "";
        return value;
    }

    private _createNumericLatField = (model: string): NumericTextBoxField => {
        let field = {
            model: model,
            name: "geocodeitem_" + model,
            format: "n7",
            decimals: 7,
            min: -90,
            max: 90,
            spinners: true
        }
        return field as NumericTextBoxField;
    }
    
    private _createNumericLngField = (model: string): NumericTextBoxField  => {
        let field = {
            model: model,
            name: "geocodeitem_" + model,
            format: "n7",
            decimals: 7,
            min: -180,
            max: 180,
            spinners: true
        }
        return field as NumericTextBoxField;
    }

    private _createTextField = (name: string): TextBoxField => {
        let field = {
            multiLine: false,
            name: "entity.AdvMaschAdrLocation." + name
        }
        return field as TextBoxField;
    }
    
    private _getNameBoolField(): string {
        if (this._geoCodeOwner == GeoCodeOwner.Address)
            return this.state.translations['GeoMap.UseAnotherAdrLocation'];
        if (this._geoCodeOwner == GeoCodeOwner.Resource)
            return this.state.translations['GeoMap.UseAnotherResLocation'];
        return this.state.translations['GeoMap.UseAnotherMaschLocation'];
    }
    
    private _creteBoolField = (model: string, name: string = null) => {
        return {
            model: model,
            type: "checkbox",
            name: name != null ? name : this._getNameBoolField(),
            labelAndControlCombined: true
        };
    }

    private _setMarkerAndUpdateLocation = (lat: number, lng: number, address?: any, addressLine?: string, update: boolean = true, showInfoWindow: boolean = false, mapCreated: boolean = false) => {
        if (update) {
            this._setGeocodeValues(lat, lng);
        }
        else {
            this._cartographer.setZoom(16);
        }

        let geojsonFeature = {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [(lng || 0), (lat || 0)]
            },
            properties: {
                adrnr: (address ? address.AdrNr : null),
                name: (address ? address.AdrName : null),
                address: (addressLine || null)
            }
        }
        
        if (this._getLocation()) {
            if (this._geoCodeOwner == GeoCodeOwner.Machine) {
                if (this._getUseAdvMaschAdrLocation()) {
                    //render custom address
                    delete geojsonFeature.properties.adrnr;
                    geojsonFeature.properties.name = this.state.translations['GeoMap.CustomAddress'];
                }
                else {
                    //render point
                    delete geojsonFeature.properties.adrnr;
                    delete geojsonFeature.properties.address;
                    geojsonFeature.properties.name = this.state.translations['GeoMap.CustomCoordinates'];
                }
            } else {
                //render point
                delete geojsonFeature.properties.adrnr;
                delete geojsonFeature.properties.address;
                geojsonFeature.properties.name = this.state.translations['GeoMap.CustomCoordinates'];
            }
        } else {
            //render original address -> no changes needed
        }
        
        this._cartographer.setMarkerAndUpdateLocation(geojsonFeature, showInfoWindow, mapCreated);
    }

    private _setAddress = () => {
        if (this.props.entity.AddressData != null) {
            this._address = this.props.entity.AddressData;
        } else {
            this._address = this.props.entity;
        }
        
        this._addressLine = (this._address.Strasse || '') + " " + (this._address.Ort || '') + " " +
            (this._address.Plz || '') + " " + (this._getLandTranslation(this._address.Land) || '');
        
        if (this._geoCodeOwner == GeoCodeOwner.Machine)
        {
            if (!Helper.hasValue(this.props.entity.AdvMaschAdrLocation)) {
                this.props.entity.AdvMaschAdrLocation = {
                    Strasse: this._address.Strasse,
                    Ort: this._address.Ort,
                    Plz: this._address.Plz,
                    Land: this._address.Land
                }
            }
            
            if (this._getLocation() && this._getUseAdvMaschAdrLocation()) {
                this._addressLine = (this.props.entity.AdvMaschAdrLocation.Strasse || '') + " " +
                    (this.props.entity.AdvMaschAdrLocation.Ort || '') + " " +
                    (this.props.entity.AdvMaschAdrLocation.Plz || '') + " " +
                    (this._getLandTranslation(this.props.entity.AdvMaschAdrLocation.Land) || '');
            }
        } 
      
        this._addressLine = this._addressLine.trim();
    }
    
    private _setCodeOwner() {
        if (this.props.entity.UseMaschLocation === true || this.props.entity.UseMaschLocation === false) 
            this._geoCodeOwner = GeoCodeOwner.Machine;
        else
        if (this.props.entity.UseAdrLocation === true || this.props.entity.UseAdrLocation === false)
            this._geoCodeOwner = GeoCodeOwner.Address
        else
            this._geoCodeOwner = GeoCodeOwner.Resource;
    }
    
    private _getLocation(): boolean {
        var location = this._getValue(this.props.entity, this.props.useLocationModel);
        //console.log("location="+location);
        return location;
    }

    private _getUseAdvMaschAdrLocation(): boolean {
        return this._geoCodeOwner == GeoCodeOwner.Machine ? this._getValue(this.props.entity, "UseAdvMaschAdrLocation") : false;
    }
    
    private _geocodeClickHandler = () => {
        this._geocodeAddress();
    }

    private _onAddressLineChange = (field: any, value: any) => {
        this.props.onChange({ model: field.name }, value);
        this._setAddress();
    }


    private _getLandTranslations = () => {
         return HTTPService.get("AddressLookup/GetLandTranslations", { });
    }
    
    private _getLandTranslation = (landDeutsch: string): string => {
        if (this._landDictionary == null)
            return landDeutsch;
        let land = this._landDictionary[landDeutsch];
        if (!Helper.hasValue(land))
            land = landDeutsch;
        return land;
    } 
    
    private _geocodeInternalAddress = (addressLine: string, mapCreated: boolean = false) => {
        if (addressLine != null) {
           this._cartographer.geocode(addressLine).then((result) => {
                this.props.onChange({ model: "SetGoogleMapsChangeDate" }, true);
                if (this._geoCodeOwner == GeoCodeOwner.Machine)
                    this.props.onChange({ model: "UseAdvMaschAdrLocation" }, true);
                this._setMarkerAndUpdateLocation(
                    Helper.truncateByDecimalPlace(Number(result[0].geometry.location.lat()), 7),
                    Helper.truncateByDecimalPlace(Number(result[0].geometry.location.lng()), 7),
                    null, addressLine, true, true);
                if (mapCreated) {
                    NotificationHelper.showInfoMessage(this.state.translations['GeoMap.NewGeocodeForAddress']);
                }
            }, (status: google.maps.GeocoderStatus) => {
                console.log(status.toString());
                NotificationHelper.showErrorMessage(this.state.translations["GeoMap.LocationError"]);
            });
        } else {
            NotificationHelper.showErrorMessage(this.state.translations['GeoMap.EmptyAddress']);
        }
    }
    
    private _geocodeAddress = async (mapCreated: boolean = false) => {
        if (!this._getDisabled()) {
            let addressLine = this._addressLine;
            if (this._geoCodeOwner == GeoCodeOwner.Machine && this._getUseAdvMaschAdrLocation() && this._getLocation()) {
              
                addressLine =
                    (this.props.entity.AdvMaschAdrLocation.Strasse || '') + " " +
                    (this.props.entity.AdvMaschAdrLocation.Ort || '') + " " +
                    (this.props.entity.AdvMaschAdrLocation.Plz || '') + " " +
                    (this._getLandTranslation(this.props.entity.AdvMaschAdrLocation.Land) || '');
            }
            
            await this._geocodeInternalAddress(addressLine, mapCreated);
        }
    }

    private _getDisabled = () => {
        const disabled = (!this.props.entity.IsNew && !this.props.entity.RecordRight.CanWrite) || !this._getLocation();
        //console.log("_getDisabled="+disabled);
        return disabled;
    }

    handleMapClick = (e: any) => {
        if (!this._getDisabled()) {
            if (this._geoCodeOwner == GeoCodeOwner.Machine)
                this.props.onChange({ model: "UseAdvMaschAdrLocation" }, false);
            this._setMarkerAndUpdateLocation(
                Helper.truncateByDecimalPlace(e.latLng.lat(), 7),
                Helper.truncateByDecimalPlace(e.latLng.lng(), 7),
                null, "", true, true);
        }
    }

    handleMapCreated = (lat: number, lng: number, cartographer: Cartographer) => {
        this._cartographer = cartographer;
        if (!lat || !lng)
            this._geocodeAddress(true);
        else
        {
            this._setMarkerAndUpdateLocation(lat, lng, this._address, this._addressLine, false, false, true);
        }
    }

    componentDidMount() {
        Promise.all(
            [Helper.getTranslations(["GeoMap.LocationError", "GeoMap.EmptyAddress", "GeoMap.MarkiereAdresse",
                "GeoMap.Breitengrad", "GeoMap.Laengengrad", "GeoMap.InfoKlickFuerGeokodierung", "Adresse.Adresse", 
                "GeoMap.NewGeocodeForAddress", "GeoMap.NoApiKey", "GeoMap.UseAnotherMaschLocation", 
                "GeoMap.Street", "GeoMap.City", "GeoMap.PostalCode", "GeoMap.Country",
                "GeoMap.UseAnotherAdrLocation", "GeoMap.UseAnotherResLocation", "GeoMap.CustomAddress", "GeoMap.CustomCoordinates"]), 
                this._geomapService.getConfig(),
                this._getLandTranslations()
            ]).then((values: Array<any>) => {
                this._landDictionary = values[2];
                this._setCodeOwner();
                this._setAddress();
                this.setState({ translations: values[0].Data, pinConfig: values[1].pinTypes });
            }, (reason) => {
                console.error(`"Error loading config/translations: ${reason}"`);
            });
        this.props.actionCallbacks.afterSavedSuccessfully = () => {
            this._setMarkerAndUpdateLocation(this._getValue(this.props.entity, this.props.latModel), this._getValue(this.props.entity, this.props.lngModel), this._address, this._addressLine, false, true);
        }
    }

    componentDidUpdate() {
    }

    private renderDropDownLand = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.value = this.props.entity.AdvMaschAdrLocation.Land;
        props.field.dataSourceUrl = "AddressLookup/GetSpesen"
        props.field.dataTextField = "Land";
        props.field.dataValueField = "Landdeutsch";
        props.field.model = "AdvMaschAdrLocation.Land";
        props.disabled = this._getDisabled();
        props.onChange = (field: { model: string }, value: any) => {
            let entity = this.props.entity;
            entity.AdvMaschAdrLocation.Land = value;
            this._setAddress();
        }
        props.onDataLoaded = () => { };
        return (<div style={{ width: "100%"}}> <DropDownList {...props} /> </div> );
    }
    
    private renderAdrEditing = () => {
        const ddLand = this.renderDropDownLand();
        
        return (
            <div>
                <label className="geomap__geocode-input-label">{this.props.translations["GeoMap.Street"]}:</label>
                <div style={{ display: "flex" }} data-role="geo-coding">
                    <TextBox 
                        value={this.props.entity.AdvMaschAdrLocation.Strasse} 
                        field={this._createTextField("Strasse")} 
                        onChange={this._onAddressLineChange} 
                        disabled={this._getDisabled()} />
                    <Button 
                        handleClick={this._geocodeClickHandler} 
                        title={this.props.translations["GeoMap.MarkiereAdresse"]} 
                        iconName={"map-marker-alt"}
                        buttonStyle={{ borderRadius: "var(--rounded-right)", borderColor: "#ced4da", borderLeft: "none" }}
                        readOnly={this._getDisabled()}
                    />
                </div>
                <label className="geomap__geocode-input-label">{this.props.translations["GeoMap.City"]}: </label>
                <div style={{ display: "flex" }}>
                    <TextBox
                        value={this.props.entity.AdvMaschAdrLocation.Ort}
                        field={this._createTextField("Ort")}
                        onChange={this._onAddressLineChange}
                        disabled={this._getDisabled()} />
                </div>
                <label className="geomap__geocode-input-label">{this.props.translations["GeoMap.PostalCode"]}: </label>
                <div style={{ display: "flex" }}>
                    <TextBox
                        value={this.props.entity.AdvMaschAdrLocation.Plz}
                        field={this._createTextField("Plz")}
                        onChange={this._onAddressLineChange}
                        disabled={this._getDisabled()} />
                </div>
                <label className="geomap__geocode-input-label">{this.props.translations["GeoMap.Country"]}: </label>
                <div style={{ display: "flex" }}>
                    {ddLand}
                </div>
                <div style={{ marginTop: "10px" }}>
                    <CheckBox field={this._creteBoolField("UseAdvMaschAdrLocation", this.props.translations["GeoMap.CustomGeoMap.CustomCoordinates"])}
                          value={!this._getUseAdvMaschAdrLocation()}
                          onChange={this.handleUseAdvOnChange}
                          disabled={this._getDisabled()}  />
                </div>
            </div>);
    }
    
    handleLatLngOnChange = (field: { model: string }, value: any) => {
        //console.log(field.model+"="+value);
        if (this._geoCodeOwner == GeoCodeOwner.Machine)
            this.props.onChange({ model: "UseAdvMaschAdrLocation" }, false);
        this.props.onChange(field, value);
        this.setState({});
    }

    handleUseAdvOnChange = (field: { model: string }, value: any) => {
        this.props.onChange({ model: "UseAdvMaschAdrLocation" }, !value);
        if (!value)
            this._geocodeClickHandler();
    }
    
    private _refresh = async () => {
        if (this._geoCodeOwner == GeoCodeOwner.Machine)
        {
            if (!this._getLocation() && Helper.hasValue(this.props.entity.AddressData)) {
                //restore orig location

                let res = await this._geomapService.getAddressById(this.props.entity.AddressData.AdrNr);

                this.props.entity.AddressData.Strasse = res.Data.Strasse;
                this.props.entity.AddressData.Ort = res.Data.Ort;
                this.props.entity.AddressData.Plz = res.Data.Plz;
                this.props.entity.AddressData.Land = res.Data.Land;
                this.props.entity.AddressData.Breitegrad = res.Data.Breitegrad;
                this.props.entity.AddressData.Laengegrad = res.Data.Laengegrad;
                this.props.entity.AddressData.UseAdrLocation = res.Data.UseAdrLocation;

                this._setAddress();

                this._setMarkerAndUpdateLocation(this.props.entity.AddressData.Breitegrad, this.props.entity.AddressData.Laengegrad, this._address, this._addressLine, true, true);
            } else
            {
                if (this._getUseAdvMaschAdrLocation())
                    //obtain custom address
                    this._geocodeClickHandler();
                else
                    //show custom point
                    this._setMarkerAndUpdateLocation(this._getValue(this.props.entity, this.props.latModel), this._getValue(this.props.entity, this.props.lngModel), this._address, this._addressLine, false, true);
            }
        } else
            //show point or address
            this._setMarkerAndUpdateLocation(this._getValue(this.props.entity, this.props.latModel), this._getValue(this.props.entity, this.props.lngModel), this._address, this._addressLine, false, true);

    }
    
    handleUseLocationOnChange = async (field: { model: string }, value: any) => {
        this.props.onChange({ model: this.props.useLocationModel }, value);
        this._setAddress();
        if (!value)
            await this._geocodeInternalAddress(this._addressLine);
        this._refresh();
    }  
    
    
    private renderLocationEditor = () => {
        const adrEditing = this._geoCodeOwner == GeoCodeOwner.Machine ? this.renderAdrEditing() : null;
        const info = this._getDisabled() ? null : 
            (<div className="geomap__geocode-input-line"><label className="geomap__geocode-input-label"><small>* {this.props.translations["GeoMap.InfoKlickFuerGeokodierung"]}</small></label></div>);
        
        return (
                <div>
                    {adrEditing}
                    <div className="geomap__geocode-input-line"><label className="geomap__geocode-input-label"> {this.props.translations["GeoMap.Breitengrad"]}*: </label>
                        <IsNumericTextBox 
                            field={this._createNumericLatField(this.props.latModel)} 
                            value={this._getValue(this.props.entity, this.props.latModel)}
                            onChange={this.handleLatLngOnChange} 
                            disabled={this._getDisabled() || this._getUseAdvMaschAdrLocation()} />
                    </div>
                    <div className="geomap__geocode-input-line"><label className="geomap__geocode-input-label"> {this.props.translations["GeoMap.Laengengrad"]}*: </label>
                        <IsNumericTextBox 
                            field={this._createNumericLngField(this.props.lngModel)} 
                            value={this._getValue(this.props.entity, this.props.lngModel)}
                            onChange={this.handleLatLngOnChange} 
                            disabled={this._getDisabled() || this._getUseAdvMaschAdrLocation()} />
                    </div>
                    {info}
            </div > );
    }
    
    render() {
        if (this.state.translations != null && this.state.pinConfig != null) {
            const locationEditor = this.renderLocationEditor();
            return (
                    <div className="flex-container flex-container--row">

                        <div className="geomap__mask-flex" style={{padding:10}}>
                            <div className="geomap__geocode-mask-react">
                                <CheckBox field={this._creteBoolField(this.props.useLocationModel)}
                                          value={this._getValue(this.props.entity, this.props.useLocationModel)}
                                          onChange={this.handleUseLocationOnChange}
                                          disabled={this.props.disabled}  />
                                {locationEditor}
                            </div>
                        </div>
                        <div className="geomap__content-geocode flex-container__item">
                            <Map lat={this._getValue(this.props.entity, this.props.latModel)} lng={this._getValue(this.props.entity, this.props.lngModel)} clickHandler={this.handleMapClick}
                                mapCreated={this.handleMapCreated} enableTrafficInformation={false} translations={this.state.translations} pinConfig={this.state.pinConfig}></Map>
                        </div>
                    </div>);
        }
        return null;
    }
}
export interface GeocodeCommonProps {
    useLocationModel: string;
    latModel: string;
    lngModel: string;
    onAddressLineChange(field: any, value: any): void;
    translations: any;
    disabled: boolean;
}

enum GeoCodeOwner {
    Machine,
    Address,
    Resource
}